module.exports = __webpack_public_path__ + "img/Ov01-19930013-464.ac57b2b1.jpg";